import { formPostRequest, imageUploadParams } from "helpers";
import { Checklist } from "types";
import { store } from "store";
import { checklistLoaded } from "redux/slices/checklistSlice";
import { Mutex } from "async-mutex";

// Any code that syncs changes to or from the backend should be wrapped in this mutex
export const ChangeMutex = new Mutex();

export const fullSync = async () => {
  await ChangeMutex.runExclusive(fullSyncNoMutex);
};

export const fullSyncNoMutex = async () => {
  const changeCountBefore = getChanges().length;
  await formPostRequest(window.location.pathname + "/sync", {
    changes: await Promise.all(
      unsyncedChanges().map(async (change) => {
        return { ...change, images: await imageUploadParams(change) };
      }),
    ),
  }).then((checklist: Checklist) => {
    // resync if a change was created after the /sync request started
    const changeCountNow = getChanges().length;
    if (changeCountBefore < changeCountNow) {
      fullSync();
    } else {
      store.dispatch(checklistLoaded(checklist));
    }
  });
};

export const unsyncedChanges = () => {
  return getChanges()
    .filter((_) => !_.synced_to_server)
    .reverse();
};

const getChanges = () => {
  return getChecklist()?.changes || [];
};

export const getChecklist = () => {
  return store.getState().checklist.value;
};
